import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaChevronDown } from "react-icons/fa";
import axiosInstance from '../axiosInstance';
import { toast } from "react-toastify"
import "../styles/MultiSelectFilter.css"
import MultiSelectFilter from "../CommonMultiSelectFilter/MultiSelectFilter";

const ProjectFilter = ({ onApply, onReset }) => {

    const [showFilters, setShowFilters] = useState(true);
    const [project, setProject] = useState([]);
    const [plantCode, setPlantCode] = useState([]);
    const [dateRange, setDateRange] = useState([null, null]);
    const [fromDate, toDate] = dateRange;
    const [profitCenter, setProfitCenter] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [zone, setZone] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState("");

    const zoneOptions = [
        { label: "East", value: "east" },
        { label: "West", value: "west" },
        { label: "South", value: "south" },
        { label: "North", value: "north" }
    ];

    const loadProjectOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/costsolution/projects/autosuggestion",
                { params: { term: inputValue || '' } }
            );

            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadPlantCodeOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/plant_code/autosuggestion",
                { params: { term: inputValue || '' } }
            );

            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadProfitCenterOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/projects/get_profit_centre",
                { params: { term: inputValue || '' } }
            );

            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadCityOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/get_city", {
                params: { term: inputValue || "" }
            });

            return (res.data?.suggestionlist || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadStateOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/get_state", {
                params: { term: inputValue || "" }
            });

            return (res.data?.suggestionlist || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };


    const handleApply = () => {
        const isEmpty =
            !project.length &&
            !plantCode.length &&
            !fromDate &&
            !toDate &&
            !profitCenter.length &&
            !city.length &&
            !state.length &&
            !zone.length &&
            !selectedDivision;

        if (isEmpty) {
            toast.warning("Please select at least one field before applying");
            return;
        }
        onApply({
            project: project.map(v => v.value),
            plantCode: plantCode.map(v => v.value),
            fromDate,
            toDate,
            profitCenter: profitCenter.map(v => v.value),
            city: city.map(v => v.value),
            state: state.map(v => v.value),
            zone: zone.map(v => v.value),
            division: selectedDivision
        });
    };

    const handleReset = () => {
        const isAlreadyEmpty =
            !project.length &&
            !plantCode.length &&
            !fromDate &&
            !toDate &&
            !profitCenter.length &&
            !city.length &&
            !state.length &&
            !zone.length &&
            !selectedDivision;
        setProject([]);
        setPlantCode([]);
        setProfitCenter([]);
        setCity([]);
        setState([]);
        setZone([]);
         setSelectedDivision("");  
        setDateRange([null, null]);

        onReset();
        if (isAlreadyEmpty) {
            toast.warning("No filters to reset");
            return;
        }
    };

    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "40px",
            borderRadius: "12px",
            fontSize: "13px",
            width: "100%",
            borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
            boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
            "&:hover": {
                borderColor: "#454CF2",
            },
        }),
        container: (base) => ({
            ...base,
            width: "100%",
        }),
        menu: (base) => ({
            ...base,
            fontSize: "12px",
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: "250px",
            overflowY: "auto",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#F0F4F8',
            borderRadius: '4px',
            padding: '2px 6px',
            margin: '2px',
            maxWidth: '120px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#19324C',
            fontSize: '12px',
            fontWeight: 500
        }),
        valueContainer: (base) => ({
            ...base,
            maxHeight: "35px",
            height: "40px",
            overflowY: "auto",
            overflowX: "hidden",
            flexWrap: "wrap",
            alignItems: "center",
            paddingTop: "4px",
            paddingBottom: "4px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#19324C',
            ':hover': {
                backgroundColor: 'transparent',
                color: '#ff0000'
            }
        })
    };

    return (
        <div className="filter-scope" style={{
            padding: "15px",
            border: "1px solid #E5E5E5",
            borderRadius: "12px",
        }}>

            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="filter-header">Filter</p>

                {/* <div onClick={() => setShowFilters(!showFilters)} style={{ cursor: "pointer" }}>
                    <FaChevronDown style={{
                        transform: showFilters ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "0.3s"
                    }} />
                </div> */}
            </div>

            {showFilters && (
                <div className="filter-all" style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                    gap: "12px",
                    marginTop: "7px",
                }}>

                    {/* Project with Hover Drawer */}
                    <MultiSelectFilter
                        label="Project"
                        value={project}
                        onChange={(selected) => {
                            setProject(selected || []);

                            if (!selected || selected.length === 0) {
                                onApply({
                                    project: [],
                                    plantCode: plantCode.map(v => v.value),
                                    fromDate,
                                    toDate,
                                    profitCenter: profitCenter.map(v => v.value),
                                    city: city.map(v => v.value),
                                    state: state.map(v => v.value),
                                    zone: zone.map(v => v.value),
                                });
                            }
                        }}
                        loadOptions={loadProjectOptions}
                        placeholder="Select Project"
                        styles={customSelectStyles}
                    />

                    {/* Plant Code */}
                    {/* <MultiSelectFilter
                        label="Plant Code"
                        value={plantCode}
                        onChange={(selected) => {
                            setPlantCode(selected || []);

                            if (!selected || selected.length === 0) {
                                onApply({
                                    project: project.map(v => v.value),
                                    plantCode: [],
                                    fromDate,
                                    toDate,
                                    profitCenter: profitCenter.map(v => v.value),
                                    city: city.map(v => v.value),
                                    state: state.map(v => v.value),
                                    zone: zone.map(v => v.value),
                                });
                            }
                        }}
                        loadOptions={loadPlantCodeOptions}
                        placeholder="Select Plant Code"
                        styles={customSelectStyles}
                    /> */}

                    {/* Date Range */}
                    <div className='filter-field'>
                        <p className="filter-text">Project Date Range</p>
                        <DatePicker
                            selectsRange
                            startDate={fromDate}
                            endDate={toDate}
                            onChange={(update) => {
                                setDateRange(update);

                                const [start, end] = update;
                                if (!start && !end) {
                                    onApply({
                                        project: project?.value || null,
                                        plantCode: plantCode?.value || null,
                                        fromDate: null,
                                        toDate: null,
                                        profitCenter: profitCenter?.value || null,
                                        city: city?.value || null,
                                        state: state?.value || null,
                                        zone: zone?.value || null,
                                    });
                                }
                            }}
                            isClearable
                            placeholderText="Select date range"
                        />
                    </div>

                    {/* Date Range */}
                    {/* <div className="filter-field">
                        <p className="filter-text">Job Division Type</p>
                        <select
                            className="select-filter-dropdown"
                            value={selectedDivision || ""}
                            onChange={(e) => setSelectedDivision(e.target.value)}
                        >
                            <option value="">Select</option>
                            <option value="scs">SCS</option>
                            <option value="ff">FF</option>
                        </select>
                    </div> */}

                    {/* Profit center */}
                    {/* <MultiSelectFilter
                        label="Profit Center"
                        value={profitCenter}
                        onChange={(selected) => {
                            setProfitCenter(selected || []);

                            if (!selected || selected.length === 0) {
                                onApply({
                                    project: project.map(v => v.value),
                                    plantCode: plantCode.map(v => v.value),
                                    fromDate,
                                    toDate,
                                    profitCenter: [],
                                    city: city.map(v => v.value),
                                    state: state.map(v => v.value),
                                    zone: zone.map(v => v.value),
                                });
                            }
                        }}
                        loadOptions={loadProfitCenterOptions}
                        placeholder="Select Profit Center"
                        styles={customSelectStyles}
                    /> */}

                    {/* City */}
                    <MultiSelectFilter
                        label="City"
                        value={city}
                        onChange={(selected) => {
                            setCity(selected || []);

                            if (!selected || selected.length === 0) {
                                onApply({
                                    project: project.map(v => v.value),
                                    plantCode: plantCode.map(v => v.value),
                                    fromDate,
                                    toDate,
                                    profitCenter: profitCenter.map(v => v.value),
                                    city: [],
                                    state: state.map(v => v.value),
                                    zone: zone.map(v => v.value),
                                });
                            }
                        }}
                        loadOptions={loadCityOptions}
                        placeholder="Select City"
                        styles={customSelectStyles}
                    />

                    {/* State */}
                    <MultiSelectFilter
                        label="State"
                        value={state}
                        onChange={(selected) => {
                            setState(selected || []);

                            if (!selected || selected.length === 0) {
                                onApply({
                                    project: project.map(v => v.value),
                                    plantCode: plantCode.map(v => v.value),
                                    fromDate,
                                    toDate,
                                    profitCenter: profitCenter.map(v => v.value),
                                    city: city.map(v => v.value),
                                    state: [],
                                    zone: zone.map(v => v.value),
                                });
                            }
                        }}
                        loadOptions={loadStateOptions}
                        placeholder="Select State"
                        styles={customSelectStyles}
                    />

                    {/* Zones */}
                   {/*  <MultiSelectFilter
                        label="Zone"
                        value={zone}
                        onChange={(selected) => {
                            setZone(selected || []);

                            if (!selected || selected.length === 0) {
                                onApply({
                                    project: project.map(v => v.value),
                                    plantCode: plantCode.map(v => v.value),
                                    fromDate,
                                    toDate,
                                    profitCenter: profitCenter.map(v => v.value),
                                    city: city.map(v => v.value),
                                    state: state.map(v => v.value),
                                    zone: [],
                                });
                            }
                        }}
                        options={zoneOptions}
                        isAsync={false}
                        placeholder="Select Zone"
                        styles={customSelectStyles}
                    /> */}

                    {/* <div className='filter-field'></div> */}

                    {/* Buttons */}
                    <div style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        gap: "10px"
                    }}>
                        <button className="jobs-cancel-btn" onClick={handleReset}>Reset</button>
                        <button className="jobs-apply-btn" onClick={handleApply}>Apply</button>
                    </div>

                </div>
            )
            }
        </div >
    );
};

export default ProjectFilter;